import { router } from './index.js'

import { Routes, RouteName, NavigationOptions } from './routes'

export async function navigateTo<T extends RouteName>(
  routeName: T,
  options?: NavigationOptions<T>
) {
  return router.push({
    name: routeName,
    query: options?.query,
    params: options?.params,
    hash: options?.hash ? '#' + options.hash : undefined
  })
}

export async function logout() {
  await navigateTo(Routes.LOGOUT)
}

export async function navigateToPath(path: string) {
  return router.push({ path })
}
